import { Flex, Icon, Image } from '@chakra-ui/react';

import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';

import design from '@/assets/images/design.png';
import designThumb from '@/assets/images/design-thumb.png';
import dev from '@/assets/images/dev.png';
import devThumb from '@/assets/images/dev-thumb.png';
import finance from '@/assets/images/finance.png';
import financeThumb from '@/assets/images/finance-thumb.png';
import hr from '@/assets/images/hr.png';
import hrThumb from '@/assets/images/hr-thumb.png';
import marketing from '@/assets/images/marketing.png';
import marketingThumb from '@/assets/images/marketing-thumb.png';
import product from '@/assets/images/product.png';
import productThumb from '@/assets/images/product-thumb.png';
import sales from '@/assets/images/sales.png';
import salesThumb from '@/assets/images/sales-thumb.png';
import support from '@/assets/images/support.png';
import supportThumb from '@/assets/images/support-thumb.png';

import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/solid';
import { useRef } from 'react';

const slideImages = [
  {
    id: 'design',
    bg: design,
    icon: designThumb,
  },
  {
    id: 'dev',
    bg: dev,
    icon: devThumb,
  },
  {
    id: 'finance',
    bg: finance,
    icon: financeThumb,
  },
  {
    id: 'hr',
    bg: hr,
    icon: hrThumb,
  },
  {
    id: 'marketing',
    bg: marketing,
    icon: marketingThumb,
  },
  {
    id: 'product',
    bg: product,
    icon: productThumb,
  },
  {
    id: 'sales',
    bg: sales,
    icon: salesThumb,
  },
  {
    id: 'support',
    bg: support,
    icon: supportThumb,
  },
];

const SlideItem = ({ data }) => {
  const { icon: IconPath } = data;
  return (
    <Flex alignItems="center" justifyContent="center">
      <Image src={IconPath} width="100px" height="100px" borderRadius="8px" />
    </Flex>
  );
};

export const defaultImage = 'design';
export const Slider = ({ selected, onChange: onChangeSlider = () => {} }) => {
  const ref = useRef();
  const properties = {
    duration: 5000,
    transitionDuration: 500,
    autoplay: false,
    defaultIndex: slideImages?.findIndex(({ id }) => id === selected),
    arrows: false,
    onChange: (_oldIndex, newIndex) => {
      onChangeSlider({ ...slideImages[newIndex] });
    },
  };
  return (
    <Flex borderRadius="12px" width="280px" height="150px">
      <Flex width="50px" justifyContent="center" alignItems="center">
        <Flex
          width="35px"
          height="35px"
          justifyContent="center"
          alignItems="center"
          borderWidth="1px"
          borderColor="#D6D5D6"
          borderRadius="full"
        >
          <Icon
            bg="white"
            width="24px"
            height="24px"
            borderRadius="full"
            cursor="pointer"
            as={ChevronLeftIcon}
            onClick={() => {
              ref?.current?.goBack();
            }}
          />
        </Flex>
      </Flex>
      <Flex width="120px" flex="1" flexDir="column" justifyContent="center">
        <Slide ref={ref} {...properties}>
          {slideImages.map((slideImage) => (
            <SlideItem data={slideImage} key={slideImage?.id} />
          ))}
        </Slide>
      </Flex>
      <Flex width="50px" justifyContent="center" alignItems="center">
        <Flex
          width="35px"
          height="35px"
          justifyContent="center"
          alignItems="center"
          borderWidth="1px"
          borderColor="#D6D5D6"
          borderRadius="full"
        >
          <Icon
            bg="white"
            width="24px"
            height="24px"
            cursor="pointer"
            borderRadius="full"
            as={ChevronRightIcon}
            set="light"
            onClick={() => {
              ref?.current?.goNext();
            }}
          />
        </Flex>
      </Flex>
    </Flex>
  );
};

export const getImage = ({ key }) => {
  const image = slideImages.find(({ id }) => id === key);
  return image?.icon || designThumb;
};

export const getBg = ({ key }) => {
  const image = slideImages.find(({ id }) => id === key);
  return image?.bg || design;
};
